module.exports = __webpack_public_path__ + "img/online_diagnostics_n_resources.01eeee31.png";